import {
  getStateIconComponent,
  getStateResultStatus,
} from '@framework/common-web/register-records/component/StateTag.tsx';
import { type AlboRecordFoDTO } from '@framework/common-web/register-records/frontoffice/api/schemas/alboRecordFoDTO.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Typography } from 'antd';
import { useMemo } from 'react';

/**
 * Custom hook per ottenere le grafiche dinamicamente in base allo stato del tesserino
 */
export function useGetUIPassInfo(record?: AlboRecordFoDTO) {
  return useMemo(() => {
    if (!record) return;

    const stato = record.statoIscrizione;
    if (!stato?.codice) return null;

    const denominazione = stato.denominazione ?? stato.codice;

    return {
      status: getStateResultStatus(stato.icona),
      icon: getStateIconComponent(stato.icona),
      label: (
        <Typography.Text>
          {t('verifica-tesserino.result.stato-tesserino', '{{stato}}', {
            stato: denominazione,
          })}
        </Typography.Text>
      ),
      subTitle: (
        <Typography.Text>
          {t(
            'verifica-tesserino.result.tesserino-attivo.description',
            'Visualizza le informazioni del tesserino nella tabella successiva.',
          )}
        </Typography.Text>
      ),
    };
  }, [record]);
}
